import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidateIntegrationService {

  constructor(private readonly http: HttpClient) { }

  validateCodeIntegration(): Observable<any> {
    return this.http.post<any>('operation/validate', null);
  }
}
